import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { defaultTo, equals, isNotNil, pipe } from "ramda";
import { gray500 } from "../../theme";
import { AwardBadgeIcon } from "./AwardBadgeIcon";
import {
  GAMIFICATION_STATUS,
  getGamificationDataStatus,
} from "./GamificationPopover";
import { useGamification } from "./GamificationProvider";

const gradients = [
  ["#4720B7", "#5AB0D2"],
  ["#4720B7", "#8C5AD9"],
  ["#4720B7", "#6DBE45"],
  ["#4720B7", "#72C3DC"],
  ["#4720B7", "#FFA07A"],
  ["#4720B7", "#FFC542"],
  ["#4720B7", "#FF6B6B"],
  ["#4720B7", "#FFB347"],
  ["#4720B7", "#2CA6A4"],
  ["#4720B7", "#D97A3A"],
  ["#4720B7", "#7B3F61"],
  ["#4720B7", "#9DE2D3"],
];

const innerSx = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: "auto",
};
export const AwardBadge = ({
  monthIndex = new Date().getMonth(),
  year,
  completed,
  width = 56,
  aspectRatio = 1.15,
  height = width * aspectRatio,
  withIcon,
}) => {
  // in design, icon with height===62 has year displayed 8px from top and 21 font size
  const scaleFactor = height / 62;
  const innerElementColor = completed ? "white" : gray500;

  return (
    <Box sx={{ position: "relative", width, height }}>
      <AwardBadgeIcon
        completed={completed}
        gradient={gradients[monthIndex]}
        width={width}
        height={height}
        withIcon={withIcon}
        iconColor={innerElementColor}
      />
      {!withIcon && isNotNil(monthIndex) && (
        <Typography
          sx={{
            ...innerSx,
            top: 8 * scaleFactor,
            fontSize: 21 * scaleFactor,
            fontWeight: 600,
            color: innerElementColor,
            textAlign: "center",
          }}
        >
          {monthIndex + 1}
        </Typography>
      )}
      {!withIcon && year && (
        <Typography
          sx={{
            ...innerSx,
            top: 33 * scaleFactor,
            fontSize: 9 * scaleFactor,
            fontWeight: 400,
            color: innerElementColor,
            opacity: 0.5,
            textAlign: "center",
          }}
        >
          {year}
        </Typography>
      )}
    </Box>
  );
};

export const GamificationAwardBadge = () => {
  const { userBadgesQuery, currentMonthIndex } = useGamification();

  return (
    <AwardBadge
      withIcon
      completed={pipe(
        defaultTo({}),
        getGamificationDataStatus,
        equals(GAMIFICATION_STATUS.SUCCESS),
      )(userBadgesQuery.data)}
      width={40}
      height={44}
      monthIndex={currentMonthIndex}
    />
  );
};
